export default __webpack_public_path__ + "static/media/project14.6a5e933e.jpg";